import React, { useEffect, useState } from 'react';
import { Button, Card, Form, message, Modal, Tooltip, Typography } from 'antd';
import { ExpandOutlined, CompressOutlined, InfoCircleOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { PptData } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { submitMissingPPT, submitMissingPPTDataReset } from '../../redux/about/actionCreator';

const { Text } = Typography
const ViewPPTDetails = ({ data, modelId }) => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [isExpanded, setIsExpanded] = useState(false);
    const [isInfo, setIsInfo] = useState(false)

    const submitMissingPPTData = useSelector(state => state.submitAboutMissingPPTInfoData)
    const { error, loading } = submitMissingPPTData
    const handleExpand = () => setIsExpanded(true);
    const handleMinimize = () => setIsExpanded(false);
    const handleInfoClick = () => setIsInfo(true)

    const handleModelSubmit = async (value) => {
        try {
            const payload = {
                model_id: modelId,
                ppt_id: data.id,
                notes: value.ppt_notes,
            };

            console.log(payload);
            await dispatch(submitMissingPPT(payload));
        } catch (error) {
           message.error(error?.message || 'Something went wrong while submitting.');
        }
    };

    useEffect(() => {
        console.log("submitMissingPPTData", submitMissingPPTData.data)
        if (error) {
            message.error(error)
        }
        if (submitMissingPPTData.data?.status) {
            message.success(submitMissingPPTData.data.message)
            form.resetFields();
            setIsInfo(false)
            dispatch(submitMissingPPTDataReset())
        }
    }, [submitMissingPPTData])
    if (!data?.embed_code) return null;

    return (
        <>
            <Card title={data.rule_name || 'PPT Details'} extra={
                <>
                    <Button type="text" icon={<ExpandOutlined />} onClick={handleExpand} />
                    <Tooltip title="Add Info">
                        <Button
                            type="text"
                            icon={<InfoCircleOutlined />}
                            onClick={handleInfoClick}
                            style={{ color: 'orange', fontSize: 16 }}
                        />
                    </Tooltip>
                </>
            } style={{ 
                width: '100%',
                margin: '0 auto',
                borderRadius: 24,
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
                padding: 12  
                }} >
                <PptData>
                    <div className="ppt_view_details" dangerouslySetInnerHTML={{ __html: data.embed_code }} />
                </PptData>
            </Card>

            <Modal open={isExpanded} onCancel={handleMinimize} footer={<Button icon={<CompressOutlined />} onClick={handleMinimize}> Minimize </Button>} width="90%" style={{ top: 30 }} >
                <div dangerouslySetInnerHTML={{ __html: data.embed_code }} className="ppt_view_details" style={{ marginTop: '30px' }} />
            </Modal>
            <Modal open={isInfo} onCancel={() => setIsInfo(false)} maskClosable={false} footer={false}>
                {/* <Text strong>If any info missing in ppt please mention below</Text> */}
                <Form layout="vertical" onFinish={handleModelSubmit} form={form}>
                    <Form.Item name="ppt_notes" label={<Text strong>If any info missing in ppt please mention below</Text>} rules={[{ required: true, message: 'Please enter the PPT  Details' }]} >
                        <TextArea placeholder='Enter the PPT Detail' />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={loading} > {loading ? `Please wait....` : `Submit`}</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ViewPPTDetails;
